"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@aio/platform-ui";
import * as React from "react";
import { useShortcutRegistry } from "./provider";
import { useHotkey } from "./use-hotkey";

export function HelpOverlay() {
  const [open, setOpen] = React.useState(false);
  useHotkey("?", () => setOpen((o) => !o));

  const registry = useShortcutRegistry();
  const groups = React.useMemo(() => {
    const all = registry.list();
    const byScope = new Map<string, typeof all>();
    for (const s of all) {
      const arr = byScope.get(s.scope) ?? [];
      arr.push(s);
      byScope.set(s.scope, arr);
    }
    return [...byScope.entries()].sort(([a], [b]) => a.localeCompare(b));
  }, [registry, open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>Press ? at any time to toggle this overlay.</DialogDescription>
        </DialogHeader>
        <div className="space-y-6">
          {groups.map(([scope, shortcuts]) => (
            <section key={scope}>
              <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-fg-muted">
                {scope}
              </h3>
              <ul className="grid grid-cols-1 gap-y-1 sm:grid-cols-2 sm:gap-x-6">
                {shortcuts.map((s) => (
                  <li key={s.id} className="flex items-center justify-between gap-3 text-sm">
                    <span className="text-fg">{s.label}</span>
                    <kbd className="rounded border border-border bg-bg-subtle px-2 py-0.5 font-mono text-xs text-fg-muted">
                      {s.keys}
                    </kbd>
                  </li>
                ))}
              </ul>
            </section>
          ))}
          {groups.length === 0 ? (
            <p className="text-sm text-fg-muted">No shortcuts registered yet.</p>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
